<template>
<div v-if="event.name">
    <div
        v-if="template == 'vertical'"
        class="event-vertical-card-container"
    >
        <div class="event-vertical-card-container__cover-image-container">
            <img 
                :src="event.logo_path" 
                alt=""
            />
            <span 
                v-if="event.sports.length"
                class="sport-tag"
                style="border-radius:5px !important;margin:0 5px;bottom:5px;background-color:rgba(255, 255, 255, 0.75);"
            >
                {{event.sport_tag}}
            </span>
            <div class="date-small-container d-flex flex-column justify-content-center">
                <span class="event-month">{{event.month}}</span>
                <span class="event-day-of-month">{{event.day}}</span>
            </div>
        </div>
        <div class="event-vertical-card-container__body">
            <div>
                <p class="event-title">{{event.name}}</p>
            </div>
            <div>
                <div 
                    v-if="event.addresses.length"
                    class="event-address-container"
                >
                    <img
                        src="/images/map/map_marker.svg"
                        alt=""
                    />
                    <p class="event-address">{{event.card_formatted_address}}</p>
                </div>

                <div v-if="event.date_ranges.length" class="event-dates-container">
                    <img src="/images/icons/calendar_icon_orango.svg" alt="">
                    <p class="event-date">{{event.formatted_full_long_date}}</p>
                </div>
                <div class="text-right mt-2">
                    <button 
                        type="button"
                        @click="onShowDetail"
                        class="fw-600 btn btn-outline-primary"
                    >
                        {{buttonLabelText}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div 
        v-else
        class="btn-event-card"
    >
        <div
            class="event-card-short mb-0"
            :class="{'card_promoted': event.is_promoted}" 
        >
            <div class="row">
                <div 
                    class="col-4 image-container"
                    :style="backgroundImage"
                >
                    <span 
                        v-if="event.sports.length > 0"
                        v-text="event.sport_tag"
                        class="w-auto rounded-0 sport-tag"
                        style="border-radius:5px !important;margin:0 5px;bottom:5px;background-color:rgba(255, 255, 255, 0.75);"></span>
                </div>
                <div class="col-8 info-container pr-0">
                    <div class="">
                        <p class="font-12 line-height-18 company-name">
                            <span 
                                class="text-muted"
                                v-text="companyName"></span>
                        </p>
                        <p 
                            class="event-title line-height-21 font-16 text-dark"
                            v-text="event.name"></p>
                    </div>
                    <div class="">
                        <div v-if="event.addresses.length > 0" class="event-address-container">
                            <img src="/images/map/map_marker.svg" alt="">
                            <p 
                                class="font-14 fw-500 text-dark event-address"
                                v-text="event.card_formatted_address"></p>
                        </div>

                        <div v-if="event.date_ranges.length > 0" class="event-dates-container">
                            <img src="/images/icons/calendar_icon_orango.svg" alt="">
                            <p 
                                class="font-14 text-dark event-date"
                                v-text="event.formatted_full_long_date"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 image-button-container">
                <div class="d-flex justify-content-center col-4 pl-0">
                    <img 
                        v-if="event.partners.length > 0"
                        :src="eventPartnersImage"
                        class="img-fluid event-partners__logo-image"
                    />
                </div>
                <div class="col-8 pr-0">
                    <button 
                        type="button" 
                        @click="onShowDetail"
                        class="p-2 btn btn-block fw-600 btn-primary text-uppercase float-right"
                    >
                        <span v-if="!event.is_expired">{{buttonLabelText}}</span>
                        <span v-else>{{buttonLabelPastText}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'CompanyEventCard',
        props: {
            event: {
                type: Object,
                required: true
            },
            company: {
                type: Object,
                default() {
                    return {}
                }
            },
            template: {
                type: String,
                default: 'vertical'
            },
            buttonLabelText: {
                type: String,
                default: 'Visualizza'
            },
            buttonLabelPastText: {
                type: String,
                default: 'Visualizza evento'
            }
        },
        data() {
            return {}
        },
        computed: {
            companyName() {
                return this.company.public_name || this.company.name
            },
            backgroundImage() {
                return {
                    'background-image': `url(${this.event.logo_path})`
                }
            },
            eventPartnersImage() {
                if (this.event.partners.length > 0) {
                    let partner = _.head(this.event.partners)

                    return partner.url
                }
            },
        },
        methods: {
            hrefEvent(event) {
                location.href = route('event.show', event.slug)
            },
            onShowDetail() {
                location.href = route('event.show', this.event.slug)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyEventCard.vue